// extracted by mini-css-extract-plugin
export default {"component":"checkBox__component___RQr09","check":"checkBox__check___XnYED","label":"checkBox__label___4+02-"};